import { collection, doc, getDocsFromServer, getDocFromServer } from 'firebase/firestore';
import { db, functions, httpsCallable } from '../firebase';
import gradesService from './gradesService';

export async function reviewSchoolPhases(schoolId) {
  const result = await httpsCallable(functions, 'reviewSchoolPhaseConfiguration')({ schoolId });
  return result.data;
}

export async function reviewSchoolPhaseAdoption(request) {
  const result = await httpsCallable(functions, 'reviewSchoolPhaseAdoption')(request);
  return result.data;
}

export async function changeSchoolPhaseExecution(request) {
  const result = await httpsCallable(functions, 'changeSchoolPhaseExecution', {timeout: 120000})(request);
  return result.data;
}

export async function previewSchoolPhaseChanges({schoolId, phases, gradeAssignments, expectedRevision}) {
  const result = await httpsCallable(functions, 'previewSchoolPhaseConfiguration')({schoolId, phases, gradeAssignments, expectedRevision});
  return result.data;
}

export async function reviewSchoolPhaseRules(request) {
  const result = await httpsCallable(functions, 'reviewSchoolPhaseRules')(request);
  return result.data;
}

export async function reviewSchoolPhaseCalendarMappings(request) {
  const result = await httpsCallable(functions, 'reviewSchoolPhaseCalendarMappings')(request);
  return result.data;
}

export async function loadSchoolPhases(schoolId) {
  if (!schoolId) return { phases: [], revision: 0 };
  const settingsRef = doc(db, 'schools', schoolId, 'schoolPhaseSettings', 'current');
  // Prevent combining an old catalogue with a newer edit revision.
  for (let attempt = 0; attempt < 3; attempt += 1) {
    const before = await getDocFromServer(settingsRef);
    const phases = await getDocsFromServer(collection(db, 'schools', schoolId, 'schoolPhases'));
    const after = await getDocFromServer(settingsRef);
    const revision = after.exists() ? after.data().revision : 0;
    if ((before.exists() ? before.data().revision : 0) === revision) {
      return { phases: phases.docs.map(item => ({ ...item.data(), id: item.id }))
        .sort((a, b) => a.order - b.order || a.name.localeCompare(b.name)), revision };
    }
  }
  throw new Error('Phases are being updated. Please reload them before editing.');
}

export async function saveSchoolPhases({ schoolId, phases, gradeAssignments = [], revision, requestId, expectedMembershipFingerprint }) {
  if (!schoolId || !requestId) throw new Error('A school and save request are required.');
  const result = await httpsCallable(functions, 'commitSchoolPhaseConfiguration')({
    schoolId, phases: phases.map(({ id, name, order }) => ({ id, name, order })),
    gradeAssignments, expectedRevision: revision, requestId,
    ...(expectedMembershipFingerprint ? {expectedMembershipFingerprint} : {}),
  });
  gradesService.clearCache(schoolId);
  return result.data;
}
